module.exports = __webpack_public_path__ + "img/logout.fe4e1f20.svg";